<div class="flex justify-center">
    @let href = link()?.url ? link()?.url : (link()?.page_ref | pathFromItem: "page");

    <a
        [href]="href"
        [target]="link()?.url ? '_blank' : '_self'"
        class="border-primary text-body-small text-primary hover:bg-primary-98 cursor-pointer rounded-md border bg-white px-4 py-2 text-center transition-colors"
    >
        {{ link()?.translations_refs | getTranslation: "title" }}
    </a>
</div>
